import React from "react";
import PropTypes from "prop-types";
import TitleWidget from "./TitleWidget";
import _ from "../../../../../shared/utils/ObjectUtils";

class TitleWidgetContainer extends React.Component {
    render () {
        let {
            configs = {},
            isEditMode = false,
            isDashboardFullScreen = false,
            onRefreshClicked = () => {},
            onForceUpdateClick = () => {},
            onEditClick = () => {},
            onCreateClick = () => {},
            onDuplicateClicked = () => {},
            onDeleteClicked = () => {},
        } = this.props;

        const checkbox1 = !_.isNilOrEmpty(configs.checkboxGroup1) ? JSON.parse(configs.checkboxGroup1) : {};
        const checkbox2 = !_.isNilOrEmpty(configs.checkboxGroup2) ? JSON.parse(configs.checkboxGroup2) : {};

        let hasSeparator = checkbox1.hasSeparator;
        let titlePosition = checkbox2.center ? "center" : (checkbox2.right ? "right" : "left");

        return (
            <TitleWidget
                widgetDisplayName={configs.widgetDisplayName}
                isEditMode={isEditMode}
                hasSeparator={hasSeparator}
                titlePosition={titlePosition}
                isDashboardFullScreen={isDashboardFullScreen}
                onForceUpdateClick={onForceUpdateClick}
                onRefreshClicked={onRefreshClicked}
                onEditClick={onEditClick}
                onCreateClick={onCreateClick}
                onDuplicateClicked={onDuplicateClicked}
                onDeleteClicked={onDeleteClicked}
            />
        );
    }
}

TitleWidgetContainer.propTypes = {
    configs: PropTypes.object,
    isEditMode: PropTypes.bool,
    isDashboardFullScreen: PropTypes.bool,
    onDeleteClicked: PropTypes.func,
    onEditClick: PropTypes.func,
    onDuplicateClicked: PropTypes.func
};

export default TitleWidgetContainer;
